import { applyFilters } from '@wordpress/hooks'

export default class GpxComponent {
    constructor() {
        GpxComponent.bindShowGpx()
    }

    static bindShowGpx() {
        if (
            typeof window.IrisMap !== 'undefined' &&
            typeof window.IrisMap.maps !== 'undefined' &&
            window.IrisMap.maps.length > 0
        ) {
            GpxComponent.showGpx()
        } else {
            $(document).on('iris-map-is-loaded', () => {
                GpxComponent.showGpx()
            })
        }
    }

    static showGpx() {
        let linkColor = getComputedStyle(document.documentElement).getPropertyValue(
            '--iris--gpx--color',
        )
        if (!linkColor) {
            linkColor = getComputedStyle(document.documentElement).getPropertyValue(
                '--iris--link--color',
            )
        }
        const traceColor = applyFilters('iris.etourism.list_color_kml_offer', linkColor)
        window.IrisMap.maps[0].addKmlGpx(IRISCollectionTheme.data.kml, {
            // eslint-disable-line
            id: 'gpx-territory',
            color: traceColor,
            width: 3,
            fillColor: traceColor,
            fillOpacity: 0.2,
        })
    }
}
